import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const user = JSON.parse(sessionStorage.getItem("users"))?.userdatils || {};
  const userName = user?.name || 'User';
  const userRole = user?.role || 'Admin';

  const businessName = JSON.parse(sessionStorage.getItem("users"))?.userdatils?.business_name || "Default Name";
  
  // Get initials from name
  const getInitials = (name) => {
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  return (
    <header className="bg-white border-b border-gray-100 px-6 py-3 flex justify-end">
      <Link 
        to="/profile" 
        className="flex items-center gap-3 hover:bg-[#635BFF] rounded-full pl-1 pr-3 py-1 transition-all duration-200 group"
      >
        {/* Circular avatar with initials */}
        <div className="relative">
          <div className="w-9 h-9 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-medium group-hover:bg-white group-hover:text-[#635BFF] transition-colors">
            {getInitials(businessName)}
          </div>
          {/* Active status indicator */}
          <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-400 rounded-full border-2 border-white group-hover:border-[#635BFF]"></div>
        </div>

        {/* User info - appears on larger screens */}
        <div className="hidden md:block">
          <p className="text-sm font-medium text-gray-900 group-hover:text-white leading-tight transition-colors">
            {businessName}
          </p>
          {/* <p className="text-xs text-gray-500 group-hover:text-gray-200 transition-colors">
            {userRole}
          </p> */}
        </div>

        {/* Chevron icon (optional) */}
        {/* <svg 
          xmlns="http://www.w3.org/2000/svg" 
          className="h-4 w-4 text-gray-400 hidden md:block group-hover:text-white" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg> */}
      </Link>
    </header>
  );
};

export default Header;